import { ZIndex } from "emrn-design/ZIndex";
import React, { PureComponent } from "react";
import { View, Text, StyleSheet } from "react-native";
import { BottomPopup, BottomPopupInstance } from "emrn-design/BottomPopup";
import { EmTouchableText, EmTouchableOpacity } from "emrn-design/EmTouchable";

import { TradeAccountStore } from "../store";

interface SwitchUserIdProps {
  onSwictch: (userId: string) => void;
}

export class SwitchUserId extends PureComponent<SwitchUserIdProps> {
  private readonly userIdList: string[] = [];
  private popup = React.createRef<BottomPopup>();

  constructor(props: SwitchUserIdProps) {
    super(props);
    TradeAccountStore.getHistory().historyTradeUsers.forEach((item) => {
      if (item.decryptUserId && !this.userIdList.includes(item.decryptUserId)) {
        this.userIdList.push(item.decryptUserId);
      }
    });

    this.userIdList.length > 0 &&
      props.onSwictch(this.userIdList[this.userIdList.length - 1]);
  }

  private handleSwitch = () => {
    const { userIdList } = this;
    let popInst: BottomPopupInstance | undefined;

    const destroy = () => {
      if (popInst) {
        popInst.dismiss();
        popInst = undefined;
      }
    };

    const onCancel = () => destroy();

    const onPicked = (userId: string) => {
      destroy();
      this.props.onSwictch(userId);
    };

    popInst = this.popup.current?.show(
      <PickUserId {...{ onCancel, onPicked, userIdList }} />,
      { zIndex: ZIndex.popup + 10 }
    );
  };

  render() {
    if (this.userIdList.length <= 1) {
      return null;
    }

    return (
      <>
        <EmTouchableText
          style={styles.btn}
          suppressHighlighting
          onPress={this.handleSwitch}
        >
          切换账户
        </EmTouchableText>
        <BottomPopup ref={this.popup} />
      </>
    );
  }
}

const styles = StyleSheet.create({
  btn: {
    color: "#3381e3",
    fontSize: 12,
  },
  pick: {
    width: "100%",
    backgroundColor: "#eee",
  },
  pick_item: {
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
  },
  pick_userid: {
    height: 50,
    borderColor: "#eee",
    borderBottomWidth: StyleSheet.hairlineWidth,
  },
  pick_userid_text: {
    color: "#333",
    fontSize: 14,
  },
  pick_cancel: {
    height: 40,
    marginTop: 10,
  },
  pick_cancel_text: {
    color: "#3381e3",
  },
});

function PickUserId(props: {
  userIdList: string[];
  onCancel: () => void;
  onPicked: (userId: string) => void;
}) {
  return (
    <View style={styles.pick}>
      {props.userIdList.map((userId) => (
        <EmTouchableOpacity
          key={userId}
          activeOpacity={0.9}
          onPress={() => props.onPicked(userId)}
          style={[styles.pick_item, styles.pick_userid]}
        >
          <Text style={styles.pick_userid_text}>{userId}</Text>
        </EmTouchableOpacity>
      ))}
      <EmTouchableOpacity
        activeOpacity={0.9}
        onPress={props.onCancel}
        style={[styles.pick_item, styles.pick_cancel]}
      >
        <Text style={styles.pick_cancel_text}>取消</Text>
      </EmTouchableOpacity>
    </View>
  );
}
